<template>
  <div id="components-layout-demo-basic">
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <defs>
        <symbol id="icon-search" viewBox="0 0 427.83 427.94">
          <g id="layer1"><path id="circle2017" d="M192,0C86.17,0,0,86.17,0,192S86.13,384.13,192,384.13A190.78,190.78,0,0,0,311.58,342l80,79.92a21.38,21.38,0,0,0,30.25-30.21l-80-80A191.16,191.16,0,0,0,384,191.92c0-105.79-86.21-192-192-192Zm0,42.67A149.38,149.38,0,1,1,42.66,192.13q0-.08,0-.17A148.94,148.94,0,0,1,191.25,42.67Z" transform="translate(0.04 0.08)"/></g>
        </symbol>
        <symbol id="icon-ok" viewBox="0 0 1024 1024">
          <path d="M899.897143 149.965714l-51.714286 51.714286-51.725714 51.725714-51.714286 51.714286-51.725714 51.725714-51.714286 51.714286-51.725714 51.725714L537.862857 512l-51.725714 51.714286-51.714286 51.725714-51.725714 51.714286-51.714286-51.714286-51.725714-51.725714L227.542857 512l-51.725714-51.714286-51.714286-51.725714L20.662857 512l51.714286 51.725714 51.725714 51.714286 51.714286 51.714286 51.725714 51.725714 51.714286 51.714286 51.725714 51.725714 51.714286 51.714286 103.44-103.44 51.725714-51.714286 51.714286-51.725714 51.725714-51.714286 51.714286-51.725714L744.742857 512l51.714286-51.714286 51.725714-51.725714 51.714286-51.714286 51.725714-51.725714 51.714286-51.714286z" p-id="5181"></path>
        </symbol>
        <symbol id="icon-edit" viewBox="0 0 512.009 512.00">
          <g><g><path d="M397.96,330.099c-13.755,0-24.872,11.118-24.872,24.872v78.125c0,13.73-11.143,24.872-24.872,24.872H74.617c-13.73,0-24.872-11.143-24.872-24.872V109.754c0-13.73,11.143-24.872,24.872-24.872h144.509c13.754,0,24.872-11.118,24.872-24.872c0-13.754-11.118-24.872-24.872-24.872H74.617C33.478,35.136,0,68.615,0,109.754v323.342c0,41.139,33.478,74.617,74.617,74.617h273.597c41.139,0,74.617-33.453,74.617-74.617v-78.124C422.832,341.217,411.714,330.099,397.96,330.099z" /></g></g>
          <g><g><path d="M484.193,31.977c-18.057-18.057-41.637-27.161-65.39-27.658c-24.997-0.547-50.143,8.506-69.046,27.434L181.37,200.14c-24.574,24.674-38.105,57.406-38.105,92.177v55.714c0,13.754,11.118,24.872,24.872,24.872h55.714c34.772,0,67.504-13.531,92.202-38.13l168.163-168.163C521.277,129.527,521.277,69.087,484.193,31.977z M280.91,299.581c-15.247,15.197-35.543,23.579-57.057,23.579H193.01v-30.842c0-21.515,8.382-41.811,23.554-57.033l111.006-111.006l64.32,64.32L280.91,299.581z M449.023,131.467L427.06,153.43l-64.32-64.32l21.962-21.962c17.759-17.759,46.611-17.709,64.32,0C466.732,84.881,466.732,113.733,449.023,131.467z" /></g></g>
        </symbol>
      </defs>
    </svg>
    <a-layout>
      <!--   头部   -->
      <a-layout-header style="border-bottom:1px solid #eeeeee;margin-top:10px;">
        <div class="container clearfix" style="position: relative;">
          <!--   Logo   -->
          <router-link tag="a" to="/">
            <div class="logo" style="display: inline-block;height:55px;width:200px;float:left;padding-top:3px;">
              <img src="@/assets/Icons/SnippetsIcon.svg" alt="logo" style="width:38px;height:38px;vertical-align:top;">
              <span style="">Diggo Snippets</span>
            </div>
          </router-link>
          
          <!--   搜索框   -->
          <div style="float:left;margin-left:131px;height:40px;position:relative;">
            <a-auto-complete
              v-model="searchName"
              style="float:left;width:365px;"
              placeholder="Search Name"
              spellcheck="false"
              @select="onNameSelect"
              @change="onNameChange"
            >
              <template slot="dataSource">
                <a-select-option 
                    v-for="item in searchList" 
                    :key="item.employee_id"
                    :value="`${item.employee_id},${item.nickname},${item.username}`">
                  <img v-if="item.profile_picture" :src="item.profile_picture" alt="" style="width:40px;height:40px;border-radius:50%;">
                  <img v-else src="@/assets/Images/defaultavatar.jpeg" alt="" style="width:40px;height:40px;border-radius:50%;">
                  <span style="margin-left:12px;">{{ item.nickname }}</span>
                </a-select-option>
              </template>
              <a-input>
              </a-input>
            </a-auto-complete>
            <svg width="16" height="16" style="position:absolute;right:14px;top:12px;z-index:99;cursor:pointer;"><use xlink:href="#icon-search"></use></svg>
          </div>
          <div style="width:40px;height:40px;float: right;border-radius: 50%;cursor: pointer" @click="backToReport">
            <img :src="avatar" alt="" style="width:100%;height:100%;border-radius: 50%;margin-bottom:26px;">
          </div>
          <!--   个人日期选择   -->
          <a-range-picker
            v-show="snippetsDatePicker"
            :format="dateFormat"
            :value="[moment(reportStartDate),moment(reportEndDate)]"
            :allowClear=false
            style="float:right;width:300px;margin-right:24px;"
            @change="onDateRangeChange" />
          <!--   团队日期选择   -->
          <img src="@/assets/Icons/time.svg" alt="" style="float:right;width: 16px;height: 16px;position:absolute;right:84px;top:11px;z-index:99">
          <a-date-picker
            v-show="teamDatePicker"
            :format="dateFormat"
            :value="moment(reportDate)"
            placeholder="Select Date"
            :allowClear=false
            style="float:right;width:160px;margin-right:24px;"
            @change="onDateChange" />
        </div>
      </a-layout-header>
      <!--   内容   -->
      <a-layout-content>
        <!--   信息页   -->
        <div class="container">
          <div class="report">
            <div id="report-menu" class="report-menu">
              <div class="info-prof" style="display: flex">
                <div class="info-prof-avatar">
                  <img v-if="searchAvatar" :src="workList.employee_info.profile_picture" alt="">
                  <img v-if="groupAvatar" :src="'https://corp.impr-inc.com/group_avatar/' + groupWorkList.group_info.group_avatar" alt="">
                  <img v-if="!searchAvatar && !groupAvatar" src="@/assets/Images/defaultavatar.jpeg" alt="">
                </div>
                <div style="margin-left:12px;display:flex;flex-direction:column">
                  <div v-if="workList && workList.employee_info" class="info-prof-name">{{ workList.employee_info.nickname }}</div>
                  <div v-if="groupWorkList && groupWorkList.group_info" class="info-prof-name">{{ groupWorkList.group_info.group_name }}</div>
                  <div v-if="workList && workList.employee_info" class="info-prof-offer">{{ workList.employee_info.job_title }}</div>
                  <div v-if="groupWorkList && groupWorkList.group_info" class="info-prof-offer">{{ groupWorkList.group_info.group_email }}</div>
                </div>
              </div>
              <!--   切换   -->
              <div class="tab" style="margin-top:28px;">
                <a-menu
                  mode="inline"
                  style="width: 280px;border:0;"
                  :open-keys="openKeys"
                  :default-open-keys="['0']"
                  @click="handleClick"
                  @openChange="onOpenChange"
                >
                  <a-sub-menu
                    key="0"
                    id="first-sub-menu"
                    class="first-sub-menu"
                    @titleClick="snippetsChange('0')"
                  >
                    <span slot="title">
                      <img ref="myIcon" src="@/assets/Icons/Snippets.svg" alt="" style="width:24px;height:24px;display: none">
                      <img ref="myIconBlue" src="@/assets/Icons/Snippets-blue.svg" alt="" style="width:24px;height:24px;">
                      <span class="sub-menu-title">My Snippets</span>
                    </span>
                  </a-sub-menu>
                  <a-sub-menu
                    v-for="(item,index) in groupList"
                    :key="item.group_id"
                    @titleClick="groupChange(index,item.group_id,item.group_name)"
                  >
                    <span slot="title">
                      <img ref="teamIcon" src="@/assets/Icons/team.svg" alt="" style="width:24px;height:24px;">
                      <img ref="teamIconBlue" src="@/assets/Icons/team-blue.svg" alt="" style="width:24px;height:24px;display: none">
                      <span class="sub-menu-title">{{ item.group_name }}</span>
                    </span>
                    <a-menu-item
                      v-for="single in item.members"
                      :key="single.employee_id"
                      class="menu-item-user"
                      @click="urlNamePathLink(single.username)"
                    >
                      <span>{{ single.nickname }}</span>
                    </a-menu-item>
                  </a-sub-menu>
                </a-menu>
              </div>
            </div>
            <div class="report-content">
              <div v-if="contentVisible">
                <a-spin :spinning="snippetsSpinning" class="report-mysnippets">
                  <div v-show="workReportEdit" class="timeline-item-first-wrap">
                    <div style="display:flex;justify-content:space-between">
                      <div style="width:142px;position: relative">
                        <a-date-picker
                          :format="dateFormat"
                          :value="moment(workDateSelect)"
                          placeholder="Select Date"
                          :allowClear=false
                          class="reportDateSelect"
                          @change="onWorkDateChange" />
                        <img src="@/assets/Icons/time-blue.svg" alt="" style="width: 16px;height: 16px;position:absolute;left:120px;top:12px;">
                      </div>
                    </div>
                    <div id="toolbar-container1" style="display:block;margin-top:12px;"></div>
                    <div id="toolbar-container2" style="display:none;margin-top:12px;"></div>
                    <div id="toolbar-container3" style="display:none;margin-top:12px;"></div>
                    <div id="text-container1" class="text-container"></div>
                    <div id="text-container2" class="text-container"></div>
                    <div id="text-container3" class="text-container"></div>
                    <a-textarea
                      placeholder="Please enter the content of yesterday"
                      v-model="workContentYesterday"
                      class="timeline-textarea"
                      onresize="false"
                      style="white-space:pre;"
                      :autoSize="{ minRows: 3}"
                    />
                    <a-textarea
                      placeholder="Please enter the content of today"
                      v-model="workContentToday"
                      class="timeline-textarea"
                      onresize="false"
                      style="white-space:pre;"
                      :autoSize="{ minRows: 3}"
                    />
                    <a-textarea
                      placeholder="Please enter the problems at work"
                      v-model="workContentQuestion"
                      class="timeline-textarea"
                      onresize="false"
                      style="white-space:pre;"
                      :autoSize="{ minRows: 3}"
                    />
                    <div style="display:flex;justify-content:space-between;">
                      <a-button class="timeline-submit" @click="snippetsSubmit()">Add a Snippet</a-button>
                    </div>
                  </div>
                  <a-timeline>
                    <a-timeline-item ref="reportTimeLine" v-for="(item,index) in workList.record_list" :key="index">
                      <div style="display: flex;justify-content: space-between;margin-right: 9px;">
                        <div class="timeline-time" :style="{color: item.addtime == todayDate ? '#2177e9' : '#222222'}">
                          {{ moment(item.addtime).format('MMM') }}{{ moment(item.addtime).format(' DD YYYY') }}
                        </div>
                      </div>
                      <div class="timeline-textarea-history" style="padding-top:9px;">
                        <div>
                          <div class="report-wrap">
                            <span class="record-title">昨天的任务</span>
                            <div
                              class="timeline-textarea-content"
                              style="white-space:pre;width:548px;"
                              v-html="item.yesterday"
                              autoSize
                              :disabled="workChangeDate != item.addtime"
                            />
                            <!-- <span v-show="workEditStatus && workChangeDate == item.addtime" class="edit-icon"
                                  @click="compeleteReport(item.id,item.addtime, item.yesterday, item.today, item.problem , item.employee_id)" 
                            >
                              <svg width="20" height="20" fill="#dddddd"><use xlink:href="#icon-ok"></use></svg>
                            </span> -->
                            <span v-show="workReportEdit && !workEditStatus" class="edit-icon"
                                  @click="changeReport(item.id,item.addtime,item.employee_id,item.yesterday,item.today,item.problem)"
                            >
                              <svg width="20" height="20" fill="#dddddd"><use xlink:href="#icon-edit"></use></svg>
                            </span>
                          </div>
                          <div class="report-wrap">
                            <span class="record-title">今天的计划</span>
                            <div
                              class="timeline-textarea-content"
                              onresize="false"
                              style="white-space:pre;width:548px;"
                              v-html="item.today"
                              autoSize
                              :disabled="workChangeDate != item.addtime"
                            />
                          </div>
                          <div class="report-wrap">
                            <span class="record-title">遇到的问题</span>
                            <div
                              class="timeline-textarea-content"
                              onresize="false"
                              style="white-space:pre;width:548px;"
                              v-html="item.problem"
                              autoSize
                              :disabled="workChangeDate != item.addtime"
                            />
                          </div>
                        </div>
                      </div>
                    </a-timeline-item>
                  </a-timeline>
                  <a-modal
                    width="700px"
                    title="Edit"
                    :visible="workEditStatus"
                    :confirm-loading="snippetsConfirmLoading"
                    @ok="snippetsChangeOk('person')"
                    @cancel="snippetsChangeCancel"
                    class="modal-text-container"
                  >
                    <div id="toolbar-change1" style="display:block;margin-top:12px;" ></div>
                    <div id="toolbar-change2" style="display:none;margin-top:12px;"></div>
                    <div id="toolbar-change3" style="display:none;margin-top:12px;"></div>
                    <div id="text-change1" class="text-container"></div>
                    <div id="text-change2" class="text-container"></div>
                    <div id="text-change3" class="text-container"></div>
                    <a-textarea
                      placeholder="Please enter the content of yesterday"
                      v-model="workChangeYes"
                      class="timeline-textarea"
                      onresize="false"
                      style="white-space:pre;display:none;"
                      :autoSize="{ minRows: 3}"
                    />
                    <a-textarea
                      placeholder="Please enter the content of today"
                      v-model="workChangeTod"
                      class="timeline-textarea"
                      onresize="false"
                      style="white-space:pre;display:none;"
                      :autoSize="{ minRows: 3}"
                    />
                    <a-textarea
                      placeholder="Please enter the problems at work"
                      v-model="workChangePro"
                      class="timeline-textarea"
                      onresize="false"
                      style="white-space:pre;display:none;"
                      :autoSize="{ minRows: 3}"
                    />
                  </a-modal>
                </a-spin>
              </div>
              <div v-else>
                <a-spin :spinning="teamSpinning" class="report-myteam">
                  <div class="group-title"><span>{{ groupName }}</span>Work Record On {{ moment(reportDate).format('MMM') }}{{ moment(reportDate).format(' DD YYYY') }}</div>
                  <a-button 
                    v-show="this.emailButtonStatus" 
                    type="primary" 
                    @click="sendEmail(groupWorkList.group_info.group_email)"
                    style="position:absolute;right:0;"
                    >发送邮件</a-button>
                  <a-timeline class=group-timeline>
                    <a-timeline-item v-for="(item,index) in groupWorkList.userlist" :key="index">
                      <div style="display: flex;justify-content: space-between;margin-right: 9px;">
                        <div class="timeline-time" style="cursor: pointer;" @click="urlNamePathLinkClose(item.username)">
                          <span>{{ item.nickname }}</span> <span style="color: #2177e9;font-size:16px;margin-left:10px;">{{ item.job_title }} </span>
                        </div>
                      </div>
                      <div class="timeline-textarea-history" style="padding-top:9px;">
                        <div class="report-wrap">
                            <span class="record-title">昨天的任务</span>
                            <div
                              class="timeline-textarea-content"
                              onresize="false"
                              style="white-space:pre;width:548px;"
                              v-html="item.yesterday"
                              autoSize
                              :disabled="workChangeEmpId != item.employee_id"
                            />
                            <!-- <span v-show="workEditStatus && workChangeEmpId == item.employee_id && userAuthority" class="edit-icon"
                                  @click="compeleteReport(item.id, item.addtime, item.yesterday, item.today, item.problem,item.employee_id)" 
                            >
                              <svg width="20" height="20" fill="#dddddd"><use xlink:href="#icon-ok"></use></svg>
                            </span> -->
                            <span v-show="!workEditStatus && userAuthority" class="edit-icon"
                                  @click="changeReport(item.id,item.date,item.employee_id,item.yesterday,item.today,item.problem)"
                            >
                              <svg width="20" height="20" fill="#dddddd"><use xlink:href="#icon-edit"></use></svg>
                            </span>
                          </div>
                          <div class="report-wrap">
                            <span class="record-title">今天的计划</span>
                            <div
                              class="timeline-textarea-content"
                              onresize="false"
                              style="white-space:pre;width:548px;"
                              v-html="item.today"
                              autoSize
                              :disabled="workChangeEmpId != item.employee_id"
                            />
                          </div>
                          <div class="report-wrap">
                            <span class="record-title">遇到的问题</span>
                            <div
                              class="timeline-textarea-content"
                              onresize="false"
                              style="white-space:pre;width:548px;"
                              v-html="item.problem"
                              autoSize
                              :disabled="workChangeEmpId != item.employee_id"
                            />
                          </div>
                      </div>
                    </a-timeline-item>
                  </a-timeline>
                  <a-modal
                    width="700px"
                    title="Edit"
                    :visible="workEditStatus"
                    :confirm-loading="snippetsConfirmLoading"
                    @ok="snippetsChangeOk('team')"
                    @cancel="snippetsChangeCancel"
                  >
                    <div id="toolbar-change1" style="display:block;margin-top:12px;" ></div>
                    <div id="toolbar-change2" style="display:none;margin-top:12px;"></div>
                    <div id="toolbar-change3" style="display:none;margin-top:12px;"></div>
                    <div id="text-change1" class="text-container"></div>
                    <div id="text-change2" class="text-container"></div>
                    <div id="text-change3" class="text-container"></div>
                    <a-textarea
                      placeholder="Please enter the content of yesterday"
                      v-model="workChangeYes"
                      class="timeline-textarea"
                      onresize="false"
                      style="white-space:pre;display:none;"
                      :autoSize="{ minRows: 3}"
                    />
                    <a-textarea
                      placeholder="Please enter the content of today"
                      v-model="workChangeTod"
                      class="timeline-textarea"
                      onresize="false"
                      style="white-space:pre;display:none;"
                      :autoSize="{ minRows: 3}"
                    />
                    <a-textarea
                      placeholder="Please enter the problems at work"
                      v-model="workChangePro"
                      class="timeline-textarea"
                      onresize="false"
                      style="white-space:pre;display:none;"
                      :autoSize="{ minRows: 3}"
                    />
                  </a-modal>
                </a-spin>
              </div>
            </div>
          </div>
        </div>
      </a-layout-content>
    </a-layout>
    <Bug></Bug>
  </div>
</template>
<script>
import moment from 'moment'
import api from '@/common/api.js'
import Bug from '../../components/Bug.vue'
import wangEditor from 'wangeditor'



moment.suppressDeprecationWarnings = true

export default {
  name: 'Report',
  components:{
    Bug
  },
  inject: ['reload'],
  data() {
    return {
      editor1: null,                                                    //  富文本框1
      editor2: null,                                                    //  富文本框2
      editor3: null,                                                    //  富文本框3
      editor4: null,                                                    //  富文本框4
      editor5: null,                                                    //  富文本框5
      editor6: null,                                                    //  富文本框6            
      moment,                                                           //  日期
      dateFormat: 'MM-DD-YYYY',                                         //  日期格式
      todayDate: moment()                                               //  今天日期
      .format()
      .slice(0, 10),
      searchName: '',                                                   //  搜索人名
      searchList: [],                                                   //  搜索下拉框
      userList: '',                                                     //  员工列表
      groupList: [],                                                    //  所有组信息
      workList: '',                                                     //  个人工作报告列表
      groupWorkList: '',                                                //  团队工作报告列
      curUserId: '',                                                    //  当前员工编号
      groupId: '2',                                                     //  当前组别编号
      groupName: '',                                                    //  当前组别名称
      avatar: '',                                                       //  当前员工头像
      searchAvatar: '',                                                 //  搜索员工头像
      searchUserId: '',                                                 //  查找员工编号
      groupAvatar: false,                                               //  分组头像
      //  图标颜色切换 tab切换
      current: '0',
      rootSubmenuKeys: ['0', '1', '2', '3', '4', '5', '6', '7'],        //  所有tab页
      openKeys: ['0'],                                                  //  打开tab页
      contentVisible: true,                                             //  是否展示报告内容
      snippetsSpinning: false,                                          //  snippets内容加载状态
      teamSpinning: false,                                              //  team内容加载状态
      indexMark: '-1',                                                  //  默认tab标记
      //  日期切换
      snippetsDatePicker: true,                                         //  我的工作记录日期选择框
      teamDatePicker: false,                                            //  团队工作记录日期选择框
      workDateSelect: '',                                               //  我的工作记录日期
      reportDate: '',                                                   //  团队时间
      reportStartDate: '',                                              //  开始时间
      reportEndDate: '',                                                //  结束时间
      reportStatus: '',                                                 //  报告状态

      //  工作报告内容
      workDate: '',                                                     //   工作报告日期
      workContentYesterday: '',                                         //   昨天工作内容
      workContentToday: '',                                             //   今天工作内容
      workContentQuestion: '',                                          //   遇到的问题
      emailButtonStatus:'',                                             //   邮件发送按钮
      groupStatus: false,                                               //  

      //  修改工作报告
      workChangeId:'',                                                  //  修改报告Id
      workChangeDate:'',                                                //  修改报告日期
      workChangeEmpId:'',                                               //  修改人Id
      workChangeYes:'',                                                 //  修改昨日内容
      workChangeTod:'',                                                 //  修改今天内容
      workChangePro:'',                                                 //  修改问题内容
      workEditStatus: false,                                            //  修改状态
      snippetsConfirmLoading:false,                                     //  工作报告提交状态
      // userAuthority: true,                                           //  用户编辑权限
      submitTip:'修改成功'                                               //  提交文字提示
    }
  },
  computed: {
    //  工作报告输入框
    workReportEdit: function () {          
      return this.curUserId === this.searchUserId
    },
    userAuthority: function () {
      // console.log(this.$route.query.group)
      var groupId = this.$route.query.group
      if(this.$route.query.group == 'HR') {
        groupId = 1
      }else if (this.$route.query.group == 'Tech') {
        groupId = 2
      }
      var userAuthorityStatue = false
      this.groupList.forEach(item => {
        if(item.group_id == groupId) {
          item.members.forEach(member => {
            if(member.employee_id == this.curUserId) {
              userAuthorityStatue = true
            }
          })
        }
      })
      return userAuthorityStatue
    }
  },
  watch: {
    '$route'() {
      if(this.$route.params.name == undefined) {
        this.searchUserId = this.curUserId
        this.getUserWorkReport(this.searchUserId)
      }else if(this.$route.params.name !== undefined && this.$route.params.name.indexOf('group') == -1){
        this.userList.filter(item => {
          if(this.$route.params.name == item.username) {
            this.searchUserId = item.employee_id
            this.getUserWorkReport(this.searchUserId)
          }
        })
      }else if(this.$route.params.name !== undefined && this.$route.params.name.indexOf('group') != -1) {
        this.groupList.filter(item => {
          const $name = this.$route.params.name.split('group')[1]
          if($name == item.group_name.split(' ')[1]) {
            this.groupId = item.group_id
            this.groupName = item.group_name
            this.getGroupWorkReport()
          }
        })
      }else {
        this.searchUserId = this.curUserId
        this.getUserWorkReport(this.searchUserId)
      }
    }
  },
  mounted() {
    const editor1 = new wangEditor('#toolbar-container1', '#text-container1')
    const editor2 = new wangEditor('#toolbar-container2', '#text-container2')
    const editor3 = new wangEditor('#toolbar-container3', '#text-container3')
    editor1.config.placeholder = '请输入昨日工作内容'
    editor2.config.placeholder = '请输入今日工作计划'
    editor3.config.placeholder = '请输入遇到的问题'
    editor1.config.menus = [
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        'indent',
        'foreColor',
        'backColor',
        'link',
        'list',
        'justify',
        'splitLine',
    ]
    editor2.config.menus = [
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        'indent',
        'foreColor',
        'backColor',
        'link',
        'list',
        'justify',
        'splitLine',
    ]
    editor3.config.menus = [
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        'indent',
        'foreColor',
        'backColor',
        'link',
        'list',
        'justify',
        'splitLine',
    ]
    editor1.config.focus = false
    editor2.config.focus = false
    editor3.config.focus = false
    editor3.create()
    editor2.create()
    editor1.create()
    this.editor1 = editor1
    this.editor2 = editor2
    this.editor3 = editor3
    // 配置 onchange 回调函数，将数据同步到 vue 中
    this.editor1.config.onchange = (newHtml) => {
      this.workContentYesterday = newHtml
    }
    this.editor2.config.onchange = (newHtml) => {
      this.workContentToday = newHtml
    }
    this.editor3.config.onchange = (newHtml) => {
      this.workContentQuestion = newHtml
    }
    
    // 编辑区域 focus（聚焦）和 blur（失焦）时触发的回调函数。
    this.editor1.config.onfocus = function () {
      document.getElementById('toolbar-container1').style.display = 'block'
      document.getElementById('toolbar-container2').style.display = 'none'
      document.getElementById('toolbar-container3').style.display = 'none'
    }
    this.editor2.config.onfocus = function () {
      document.getElementById('toolbar-container1').style.display = 'none'
      document.getElementById('toolbar-container2').style.display = 'block'
      document.getElementById('toolbar-container3').style.display = 'none'
    }
    this.editor3.config.onfocus = function () {
      document.getElementById('toolbar-container1').style.display = 'none'
      document.getElementById('toolbar-container2').style.display = 'none'
      document.getElementById('toolbar-container3').style.display = 'block'
    }
  },
  methods: {
    //  tab切换
    handleClick(e) {
      this.current = e.key
    },
    //  自动闭合
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
    },
    //  输入框内容改变 过滤名单
    onNameChange(name) {
      if(name == '') {
        this.searchList = []
      }else {
        this.searchList = this.userList.filter(item => {
          return item.username.indexOf(name.toLowerCase()) != -1 || item.legal_name.indexOf(name) != -1
        })
      }
      
    },
    //  选择后查询更改查询id 发起请求
    onNameSelect(info) {
      this.searchUserId = info.split(',')[0]
      this.searchName = info.split(',')[1]
      //  发起请求
      this.urlNamePathLinkClose(info.split(',')[2])
      this.onOpenChange(['-1'])
    },
    //  获取团队列表
    getGroupList() {
      this.$post(api.tool.getAllGroup, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.groupList = res.list
          if(this.$route.params.name !== undefined && this.$route.params.name.indexOf('group') != -1) {
            const $name = this.$route.params.name.split('group')[1]
            this.groupList.filter(item => {
              if($name == item.group_name.split(' ')[1]) {
                this.groupId = item.group_id
                this.groupName = item.group_name
                this.getGroupWorkReport()
                this.closeChange(true)
                this.groupStatus = true;
              }
            })
          }
        }
      })
    },
    //  获取员工列表
    getUserList() {
      this.$post(api.tool.getUserList, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.userList = res.list
          if(this.$route.params.name == undefined) {
            this.searchUserId = this.curUserId
            this.getUserWorkReport(this.searchUserId)
          }else if(this.$route.params.name !== undefined && this.$route.params.name.indexOf('group') == -1){
            this.userList.filter(item => {
              if(this.$route.params.name == item.username) {
                this.searchUserId = item.employee_id
                this.getUserWorkReport(this.searchUserId)
                this.closeChange(true)
              }
            })
          }
        }
      })
    },
    //  个人切换
    snippetsChange(index) {
      //  图标切换
      const iconIndexArr = [0, 1, 2, 3, 4, 5, 6]
      iconIndexArr.forEach(item => {
        this.$refs.teamIcon[item].style.display = 'inherit'
        this.$refs.teamIconBlue[item].style.display = 'none'
      })
      if (index == 0) {
        if (this.indexMark != -1) {
          this.dateInit()
          this.$refs.myIcon.style.display = 'none'
          this.$refs.myIconBlue.style.display = 'inherit'
          this.indexMark = -1
          this.getUserWorkReport(this.curUserId)
        } else if (this.indexMark == -1) {
            this.$refs.myIcon.style.display = 'inherit'
            this.$refs.myIconBlue.style.display = 'none'
            this.indexMark = -2
        }
      }
      this.$router.push({ path: '/snippets2' })
      this.reload()
    },
    //  分组切换
    groupChange(index, groupId, groupName) {
      this.groupId = groupId
      this.groupName = groupName
      this.urlGroupPathLinkClose(this.groupName.split(" ")[1])

      //  图标切换
      this.$refs.myIcon.style.display = 'inherit'
      this.$refs.myIconBlue.style.display = 'none'

      const iconIndexArr = [0, 1, 2, 3, 4, 5, 6]
      iconIndexArr.forEach(item => {
        if (item == index) {
          if (this.indexMark != index) {
            this.dateInit()
            this.$refs.teamIcon[item].style.display = 'none'
            this.$refs.teamIconBlue[item].style.display = 'inherit'
            this.indexMark = item
            this.getGroupWorkReport()
            //  获取报告
          } else if (this.indexMark == index) {
            this.$refs.teamIcon[item].style.display = 'inherit'
            this.$refs.teamIconBlue[item].style.display = 'none'
            this.indexMark = -2
          }
          // this.$refs.teamIcon[item].style.display = 'none'
          // this.$refs.teamIconBlue[item].style.display = 'inherit'
        } else {
          this.$refs.teamIcon[item].style.display = 'inherit'
          this.$refs.teamIconBlue[item].style.display = 'none'
        }
      })
      // this.userAuthority = false
      // this.groupList.forEach(item => {
      //   if(item.group_id == groupId) {
      //     item.members.forEach(member => {
      //       if(member.employee_id == this.curUserId) {
      //         this.userAuthority = true
      //       }
      //     })
      //   }
      // })
    },
    //  获取员工工作报告
    getUserWorkReport(id) {
      // this.dateInit()
      this.searchUserId = id
      this.snippetsDatePicker = true
      this.teamDatePicker = false
      this.contentVisible = true
      this.groupAvatar = false
      //  发送请求
      this.snippetsSpinning = true
      // console.log('员工id:' + this.searchUserId, '报告日期范围:' + this.reportStartDate, this.reportEndDate, '员工报告获取')
      this.$post(api.tool.getDailyReport, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        s_date: this.reportStartDate,
        e_date: this.reportEndDate,
        ee_id: this.searchUserId
      }).then((res) => {
        if (res.code === 200) {
          this.workList = res.list
          this.groupWorkList = ''
          if (this.workList.employee_info.profile_picture != '' && this.workList.employee_info.profile_picture != null) {
            this.searchAvatar = true
          } else {
            this.searchAvatar = false
          }
          this.snippetsSpinning = false
        }
      })
    },
    //  获取组工作报告
    getGroupWorkReport() {
      this.snippetsDatePicker = false
      this.teamDatePicker = true
      this.contentVisible = false
      this.searchAvatar = false
      this.searchUserId = -1
      //发送请求
      this.teamSpinning = true
      // console.log('组id:' + this.groupId, '组名称:' + this.groupName, '报告日期:' + this.reportDate, '团队报告获取')
      this.$post(api.tool.getGroupDailyReport, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        group_id: this.groupId,
        addtime: this.reportDate
      }).then((res) => {
        if (res.code === 200) {
          this.workList = ''
          this.groupWorkList = res.list
          this.emailButtonStatus = this.groupWorkList.group_info.email_settings == '1' ? true : false
          if (this.groupWorkList.group_info.group_avatar != '' && this.groupWorkList.group_info.group_avatar != null) {
            this.groupAvatar = true
          } else {
            this.groupAvatar = false
          }
          this.teamSpinning = false
        }
      })
    },
    //  修改个人报告日期
    onWorkDateChange(date) {
      this.workDateSelect = date.format('YYYY-MM-DD')
    },
    //  个人日期变动后页面跳转
    onDateRangeChange(data, dateString) {
      this.reportStartDate = moment(dateString[0]).format('YYYY-MM-DD')
      this.reportEndDate = moment(dateString[1]).format('YYYY-MM-DD')
      //  发送请求
      this.snippetsSpinning = true
      // console.log('员工id:' + this.searchUserId, '报告日期范围:' + this.reportStartDate, this.reportEndDate, '员工报告获取，时间改变')
      this.$post(api.tool.getDailyReport, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        s_date: this.reportStartDate,
        e_date: this.reportEndDate,
        ee_id: this.searchUserId
      }).then((res) => {
        if (res.code === 200) {
          this.workList = res.list
          this.snippetsSpinning = false
        }
      })

    },
    //  团队日期变动后页面跳转
    onDateChange(date) {
      this.reportDate = date.format('YYYY-MM-DD')
      //  发送请求
      this.teamSpinning = true
      // console.log('组id:' + this.groupId, '组名称:' + this.groupName, '报告日期:' + this.reportDate, '团队报告获取,时间改变')
      this.$post(api.tool.getGroupDailyReport, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        group_id: this.groupId,
        addtime: this.reportDate
      }).then((res) => {
        if (res.code === 200) {
          this.groupWorkList = res.list
          this.teamSpinning = false
        }
      })
    },
    //  日期初始化
    dateInit() {
      this.reportDate = this.todayDate
      this.workDateSelect = this.todayDate
      this.reportStartDate = moment().subtract(6, 'days').format('YYYY-MM-DD')
      this.reportEndDate = this.todayDate
    },
    //  提交工作记录
    snippetsSubmit() {
      this.workChangeId = ''
      this.workDate = this.workDateSelect
      if (this.workContentToday == '') {
        this.$message.error('内容不能为空')
        return
      }
      //  发送请求
      // console.log(this.curUserId, this.workDate, '工作报告ID:' + this.workChangeId, this.workContentYesterday, this.workContentToday, this.workContentQuestion, '提交/修改工作记录')
      this.$post(api.tool.dealDailyReport, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        yesterday:this.workContentYesterday,
        today:this.workContentToday,
        problem:this.workContentQuestion,
        id: this.workChangeId,
        addtime: this.workDate,
        ee_id:this.curUserId
      }).then((res) => {
        if (res.code === 200) {
          this.getUserWorkReport(this.curUserId)
          if(res.list == '当前日期已经添加过') {
            this.$message.error('当前日期已经添加过')
          }else {
            this.$message.success('添加成功')
          }
          
        }
      })
      this.editor1.txt.clear()
      this.editor2.txt.clear()
      this.editor3.txt.clear()
      this.workChangeId = ''
      this.workDate = ''
      this.workContentYesterday = ''
      this.workContentToday = ''
      this.workContentQuestion = ''
      
    },
    //  修改工作记录
    changeReport(reportId,date,empId,yes,today,pro) {
      // console.log(reportId,date,empId)
      this.workEditStatus = true
      this.workChangeId = reportId
      this.workChangeDate = date
      this.workChangeEmpId = empId
      this.workContentYesterday = yes
      this.workContentToday = today
      this.workContentQuestion = pro
      // console.log(this.workContentYesterday, this.workContentToday, this.workContentQuestion)
      this.$nextTick(() => {
        // if(this.editor4 == null) {
          this.editor4 = new wangEditor('#toolbar-change1', '#text-change1')
          this.editor5 = new wangEditor('#toolbar-change2', '#text-change2')
          this.editor6 = new wangEditor('#toolbar-change3', '#text-change3')
          this.editor4.config.placeholder = '请输入昨日工作内容'
          this.editor5.config.placeholder = '请输入今日工作计划'
          this.editor6.config.placeholder = '请输入遇到的问题'  
          this.editor4.config.menus = [
            'bold',
            'italic',
            'underline',
            'strikeThrough',
            'indent',
            'foreColor',
            'backColor',
            'link',
            'list',
            'justify',
            'splitLine',
          ],
          this.editor5.config.menus = [
            'bold',
            'italic',
            'underline',
            'strikeThrough',
            'indent',
            'foreColor',
            'backColor',
            'link',
            'list',
            'justify',
            'splitLine',
          ]
          this.editor6.config.menus = [
            'bold',
            'italic',
            'underline',
            'strikeThrough',
            'indent',
            'foreColor',
            'backColor',
            'link',
            'list',
            'justify',
            'splitLine',
          ]
          this.editor4.config.focus = false
          this.editor5.config.focus = false
          this.editor6.config.focus = false
          this.editor6.create()
          this.editor5.create()
          this.editor4.create()
          // this.editor4 = editor4
          // this.editor5 = editor5
          // this.editor6 = editor6
        // }
        
        // 配置 onchange 回调函数，将数据同步到 vue 中
        this.editor4.config.onchange = (newHtml) => {
          this.workChangeYes = newHtml
        }
        this.editor5.config.onchange = (newHtml) => {
          this.workChangeTod = newHtml
        }
        this.editor6.config.onchange = (newHtml) => {
          this.workChangePro = newHtml
        }
        
        // 编辑区域 focus（聚焦）和 blur（失焦）时触发的回调函数。
        this.editor4.config.onfocus = function () {
          document.getElementById('toolbar-change1').style.display = 'block'
          document.getElementById('toolbar-change2').style.display = 'none'
          document.getElementById('toolbar-change3').style.display = 'none'
        }
        this.editor5.config.onfocus = function () {
          document.getElementById('toolbar-change1').style.display = 'none'
          document.getElementById('toolbar-change2').style.display = 'block'
          document.getElementById('toolbar-change3').style.display = 'none'
        }
        this.editor6.config.onfocus = function () {
          document.getElementById('toolbar-change1').style.display = 'none'
          document.getElementById('toolbar-change2').style.display = 'none'
          document.getElementById('toolbar-change3').style.display = 'block'
        }
        this.editor4.txt.html(this.workContentYesterday)
        this.editor5.txt.html(this.workContentToday)
        this.editor6.txt.html(this.workContentQuestion)
      })
    },
    // 报告修改
    compeleteReport(reportId, date,empId,location) {
      this.workEditStatus = false
      if(reportId == null) {
        this.submitTip = '添加成功'
        reportId = ''
      }
      if(date == null) date = this.reportDate
      if(empId == undefined) empId = this.curUserId
      // console.log(reportId, date, empId, this.workChangeYes, this.workChangeTod, this.workChangePro)
      this.$post(api.tool.dealDailyReport, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        yesterday:this.workChangeYes,
        today:this.workChangeTod,
        problem:this.workChangePro,
        id: reportId,
        addtime: date,
        ee_id:empId
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(this.submitTip)
          if(location == 'person') {
            this.getUserWorkReport(this.curUserId)
          }else {
            this.getGroupWorkReport()
          }
        }
      })
      this.workChangeId = ''
      this.workChangeDate = ''
      this.workChangeEmpId = ''
      this.editor4.destroy()
      this.editor5.destroy()
      this.editor6.destroy()
      this.editor4 = null
      this.editor5 = null
      this.editor6 = null
      // this.editor4.txt.clear()
      // this.editor5.txt.clear()
      // this.editor6.txt.clear()
    },
    // 确定修改
    snippetsChangeOk(location) {
      this.compeleteReport(this.workChangeId, this.workChangeDate, this.workChangeEmpId,location)
    },
    // 取消修改
    snippetsChangeCancel() {
      this.workEditStatus = false
      this.editor4.destroy()
      this.editor5.destroy()
      this.editor6.destroy()
      this.editor4 = null
      this.editor5 = null
      this.editor6 = null
    },
    // 发送邮件
    sendEmail(email) {
      this.$post(api.tool.sendEmailByGroup, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        group_email:email,
        send_date:this.reportDate,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('发送成功')
        }
      })
    },
    //  回到自己页面
    backToReport() {
      this.$router.push({ path: '/snippets2'})
      this.reload()
    },
    // 通过链接跳转
    urlNamePathLink(username){
      this.$router.push({ path: '/snippets2/' + username })
    },
    urlNamePathLinkClose(username){
      this.$router.push({ path: '/snippets2/' + username })
      this.closeChange(true)
    },
    urlGroupPathLinkClose(group){
      this.$router.push({ path: '/snippets2/group' + group })
    },
    // 关闭侧边栏
    closeChange(value) {
      if(value) {
        this.onOpenChange(['-1'])
      }
      this.indexMark = -2
      const iconIndexArr = [0, 1, 2, 3, 4, 5, 6]
      this.$refs.myIcon.style.display = 'inherit'
      this.$refs.myIconBlue.style.display = 'none'
        iconIndexArr.forEach(item => {
          try {
            if(this.$refs.teamIcon[item] !== 'undefined') {
              this.$refs.teamIcon[item].style.display = 'inherit'
            }
          } catch (error) {
            return
          }
          
          if(this.$refs.teamIconBlue[item] !== 'undefined') {
            this.$refs.teamIconBlue[item].style.display = 'none'
          }
        })
      
    },
    // 富文本加载
    richText() {
      const editor1 = new wangEditor('#toolbar-container1', '#text-container1')
      const editor2 = new wangEditor('#toolbar-container2', '#text-container2')
      const editor3 = new wangEditor('#toolbar-container3', '#text-container3')
      editor1.config.placeholder = '请输入昨日工作内容'
      editor2.config.placeholder = '请输入今日工作计划'
      editor3.config.placeholder = '请输入遇到的问题'
      // 配置 onchange 回调函数，将数据同步到 vue 中
      editor1.config.onchange = (newHtml) => {
        this.workContentYesterday = newHtml
      }
      editor2.config.onchange = (newHtml) => {
        this.workContentToday = newHtml
      }
      editor3.config.onchange = (newHtml) => {
        this.workContentQuestion = newHtml
      }
      editor2.config.focus = true
      // 编辑区域 focus（聚焦）和 blur（失焦）时触发的回调函数。
      editor1.config.onfocus = function () {
        document.getElementById('toolbar-container1').style.display = 'block'
        document.getElementById('toolbar-container2').style.display = 'none'
        document.getElementById('toolbar-container3').style.display = 'none'
      }
      editor2.config.onfocus = function () {
        document.getElementById('toolbar-container1').style.display = 'none'
        document.getElementById('toolbar-container2').style.display = 'block'
        document.getElementById('toolbar-container3').style.display = 'none'
      }
      editor3.config.onfocus = function () {
        document.getElementById('toolbar-container1').style.display = 'none'
        document.getElementById('toolbar-container2').style.display = 'none'
        document.getElementById('toolbar-container3').style.display = 'block'
      }


      editor1.create()
      editor2.create()
      editor3.create()

      this.editor1 = editor1
      this.editor2 = editor2
      this.editor3 = editor3
    }
  },
  created() {
    if (localStorage.impr_id && localStorage.impr_token) {
      this.avatar = localStorage.impr_picture
      this.curUserId = localStorage.impr_id
      this.searchUserId = localStorage.impr_id

      this.dateInit()
      this.getGroupList()
      this.getUserList()
      
    } else {
      this.$router.push({ path: '/login' })
    }


  },
}
</script>

<style scoped>
/* Common */
#components-layout-demo-basic a-select {
  background: #1a73e8;
}
#components-layout-demo-basic .ant-layout {
  background: #fff;
}
#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  height: 55px;
  padding: 0;
  background: #fff;
  color: #000;
}
#components-layout-demo-basic .ant-layout-content {
  background: #fff;
  color: #fff;
  min-height: 1145px;
}

.container {
  /*width: 60%;*/
  width: 1120px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  color: #000;
}
.clearfix {
  content: '';
  display: block;
  clear: both;
}

/* 日期选择 */
#components-layout-demo-basic >>> .ant-calendar-picker-input.ant-input {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  color: #333333;
  background-color: #ffffff;
  cursor: pointer;
}
#components-layout-demo-basic >>> .ant-calendar-range-picker-separator {
  margin-top: 4px;
}
#components-layout-demo-basic >>> .ant-calendar-range-picker-input {
  cursor: pointer;
}

/* Logo */
.logo span {
  line-height: 38px;
  margin-left: 10px;
  vertical-align: top;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  color: #1a73e8;
}

#components-layout-demo-basic >>> .ant-input {
  height: 40px;
  border-radius: 8px;
  background-color: #f1f3f4;
  font-size: 14px;
  border:none;
}
#components-layout-demo-basic >>> .ant-input::placeholder {
  font-size: 14px;
  color: #bbbbbb;
}
#components-layout-demo-basic >>> .certain-category-icon {
  font-size: 21px;
  color: #555555;
}

/* report */
.report {
  min-height: 1091px;
  width: 100%;
  margin-top: 40px;
  display: flex;
  z-index:99;
}
.report-menu {
  width: 320px;
  display: flex;
  flex-direction: column;
}

/* avatar name */
.info-prof {
  height: 81px;
}
.info-prof-avatar {
  margin-top: 5px;
  margin-left: 4px;
  width: 72px;
  height: 72px;
}
.info-prof-avatar img {
  height: 100%;
  width: 100%;
  border-radius: 50%;

}
.info-prof-name {
  height: 16px;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  line-height: 19px;
  color: #222222;
  margin-top: 23px;
}
.info-prof-offer {
  height: 12px;
  font-family: GoogleSans-Regular;
  font-size: 14px;
  line-height: 19px;
  color: #555555;
  margin-top: 10px;
}

/* tab */
#components-layout-demo-basic >>> .ant-menu-item {
  display: flex;
  align-content: center;
  border-radius: 0 22px 22px 0;
  height: 44px;
}
#components-layout-demo-basic >>> .first-sub-menu .ant-menu-submenu-arrow::after,
#components-layout-demo-basic >>> .first-sub-menu .ant-menu-submenu-arrow::before {
  width: 0;
  height: 0;
}
#components-layout-demo-basic >>> .ant-menu-submenu-title {
  height: 44px;
  background-color: #ffffff;
  border-radius: 0 24px 24px 0;
  color: #222222;
  padding-top:2px;

}
#components-layout-demo-basic >>> .ant-menu-submenu-open .ant-menu-submenu-title {
  height: 44px;
  background-color: #e9f0fd;
  color: #2177e9;
  border-radius: 0 24px 24px 0;
}
#components-layout-demo-basic >>> .ant-menu-item img {
  width: 24px;
  height: 24px;
  margin-top: 10px;
}
#components-layout-demo-basic >>> .ant-menu-submenu img {
  width: 24px;
  height: 24px;
}
#components-layout-demo-basic >>> .ant-menu-item span,
#components-layout-demo-basic >>> .ant-menu-submenu span.sub-menu-title {
  font-family: GoogleSans-Medium;
  font-size: 14px;
  /*color: #222222;*/
  margin-left: 18px;
}
#components-layout-demo-basic >>> .ant-menu-submenu-selected {
  color: #222222;
}
#components-layout-demo-basic >>> .ant-menu-item.ant-menu-item-selected,
#components-layout-demo-basic >>> .menu-item-user.ant-menu-item.ant-menu-item-selected {
  background-color: #ffffff;
  color: #2177e9;
}
#components-layout-demo-basic >>> .ant-calendar-picker-icon {
  display: none;
}
.ant-menu-vertical .ant-menu-item::after, .ant-menu-vertical-left .ant-menu-item::after, .ant-menu-vertical-right .ant-menu-item::after, .ant-menu-inline .ant-menu-item::after {
  border: 0;
}
#components-layout-demo-basic >>> .reportDateSelect .ant-calendar-picker-input {
  height: 40px;
  border: solid 1px #e5e5e5;
  color: rgba(0, 0, 0, 0.65);
  width: 150px;
}
#components-layout-demo-basic >>> .ant-calendar-picker-input.ant-input-disabled {
  background-color: #fafafa;
  color: #bbbbbb;
}
/* timeline */
.ant-timeline {
  margin-top: 30px;
}
#components-layout-demo-basic >>> .ant-timeline-item-head {
  width: 14px;
  height: 14px;
  background-color: #bbbbbb;
  border-radius: 7px;
  border: 0;
  margin-left: 1px;
}
.timeline-item-first-wrap {
  width: 792px;
  /* height: 265px; */
  background-color: #ffffff;
  border-radius: 8px;
  border: solid 2px rgba(33, 119, 233, 0.5);
  padding: 24px 25px 24px 23px;
  margin-top: 22px;
  /*margin-left: 22px;*/
}
/*#components-layout-demo-basic >>> .ant-timeline-item:first-child .ant-timeline-item-head {*/
/*  width: 16px;*/
/*  height: 16px;*/
/*  background-color: #2177e9;*/
/*  border-radius: 8px;*/
/*  margin-left: 0;*/
/*}*/
#components-layout-demo-basic >>> .ant-timeline-item-tail {
  margin-left: 3px;
}
.timeline-time {
  height: 20px;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  color: #222222;
  line-height: 19px;
  letter-spacing: 0;
  margin-top: 5px;
}
.timeline-time:hover {
  color: #2177e9;
}

.first-timeline-item {
  display: flex;
}
.first-timeline-item .timeline-time {
  color: #2177e9;
}
#components-layout-demo-basic >>> .group-timeline .ant-timeline-item-tail,
#components-layout-demo-basic >>> .group-timeline .ant-timeline-item-head {
  display: none;
}
#components-layout-demo-basic .timeline-textarea {
  width: 745px;
  height: 109px;
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  margin-top: 12px;
  resize: none;
  display: none;
}
#components-layout-demo-basic .timeline-textarea-content {
  width: 745px;
  min-height:60px;
  height: auto;
  background-color: #ffffff;
  /* border: 1px solid rgba(0, 0, 255, 0.1); */
  border-radius: 8px;
  resize: none;
}
#components-layout-demo-basic .timeline-textarea-content.ant-input-disabled {
   width: 745px;
  height: 109px;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 8px;
  resize: none;
  color: rgba(0, 0, 0, 0.65);
}
#components-layout-demo-basic .timeline-textarea::placeholder {
  color: #bbbbbb;
}
#components-layout-demo-basic .timeline-textarea-history {
  width: 754px;
  min-height: 176px;
  background-color: #ffffff;
  box-shadow: 0px 0px 15px 1px rgba(17, 17, 17, 0.06);
  border-radius: 8px;
  margin-top: 27px;
}
#components-layout-demo-basic >>> .ant-timeline-item-content {
  display: flex;
  flex-direction: column;
  margin-left: 38px;
}
#components-layout-demo-basic .timeline-submit {
  width: 150px;
  height: 40px;
  background-color: #2177e9;
  border-radius: 8px;
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #ffffff;
  margin-top: 12px;
}

/* 编辑报告 */

.report-wrap {
  display: flex;
  align-items: center;
  min-height: 30px;
  margin-left: 32px;
  border-bottom: 1px solid #f5f5f5;
  padding-top: 15px;
  padding-bottom: 15px;
}
.report-wrap:last-child {
  border-bottom: 0;
}
.record-title {
  width: 100px;
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #555555;
}
.record-content {
  width: 460px;
  font-family: "PingFang SC";
  font-size: 14px;
  color: #333333;
}
.record-process {
  width: 38px;
  margin-left: 30px;
}
.delete-icon, .edit-icon {
  margin-top: 3px;
  margin-left: 30px;
}
svg {
  cursor: pointer;
  z-index: 999;
}

.delete-icon:hover svg {
  fill: #2177e9;
}
.edit-icon:hover svg {
  fill: #2177e9;
}

.group-title {
  font-family: GoogleSans-Bold;
  font-size: 28px;
  color: #222222;
}
.group-title span {
  color: #2177e9;
}
.text-container {
  border: 1px solid #e5e5e5;
  border-radius:8px;
  margin-top:12px;
  min-height:60px;
}
#components-layout-demo-basic >>> .w-e-text-container {
  border-radius:8px;
}
#components-layout-demo-basic >>> .w-e-toolbar {
  padding:0;
}
ol {
  padding-left:0 !important;
}
#components-layout-demo-basic >>> .timeline-textarea-content >>> ol{
  padding-left:0;
}
#components-layout-demo-basic >>> .modal-text-container .w-e-text-container {
  background-color:red;
}
</style>
